import { RateLimit } from '@/types/app.types';
import { WorkspaceRateLimit } from '@/types/generated/graphql';

const segment_count = 160;

export function hasLimitReached(limits?: WorkspaceRateLimit[]) {
  let limitReached = false;

  if (!limits) return limitReached;

  limitReached = limits?.some((limit) => {
    if (limit?.category === 'call') {
      return limit.exhaust?.value === limit.timeLimit;
    } else {
      return limit?.exhaust?.value === Number(limit?.segmentLimit) * segment_count;
    }
  });

  return limitReached;
}

export function getParsedLimits(limits?: WorkspaceRateLimit[]) {
  return (
    limits?.map((rateLimit) => {
      const percent = (((rateLimit?.exhaust?.value as number) / Number(rateLimit?.threshold)) * 100).toFixed();

      return {
        ...rateLimit,
        total: rateLimit?.threshold,
        rateType: (rateLimit?.direction + '-' + rateLimit.category) as RateLimit,
        percent: +percent,
      };
    }) ?? []
  );
}

export function getMaxUsedPercent(limits?: ReturnType<typeof getParsedLimits>) {
  const maxUsedPercent = limits?.sort((a, b) => b?.percent - a?.percent)?.[0]?.percent;

  return maxUsedPercent || 0;
}

export function hasMessageLimit(limits?: ReturnType<typeof getParsedLimits>) {
  const messageLimit = limits?.find((limit) => limit?.category === 'message' && limit?.percent >= 100);

  return !!messageLimit;
}
export function hasCallLimit(limits?: ReturnType<typeof getParsedLimits>) {
  const callLimit = limits?.find((limit) => limit?.category === 'call' && limit?.percent === 100);

  return !!callLimit;
}
